module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-form', {
    ref: "inviteForm",
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-btn', {
    class: !_vm.formValid ? 'grey lighten-1' : _vm.userRole == _vm.rootRoleName ? 'red darken-3' : 'primary',
    attrs: {
      "disabled": !_vm.formValid,
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.registAccount($event)
      }
    }
  }, [(_vm.userRole == _vm.rootRoleName) ? _c('span', [_vm._v("P/C ルートアカウントの発行 (メールの送信)")]) : _c('span', [_vm._v(_vm._s(_vm.$t("account.invite-btn")))])]), _vm._v(" "), _c('span', {
    staticClass: "blue--text"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('account.csv-import')) + "\n        ")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-3",
    attrs: {
      "xs12": "",
      "sm6": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('user-params.username'),
      "rules": _vm.usernameRules,
      "required": ""
    },
    model: {
      value: (_vm.edit.username),
      callback: function($$v) {
        _vm.$set(_vm.edit, "username", $$v)
      },
      expression: "edit.username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-3",
    attrs: {
      "xs12": "",
      "sm6": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('user-params.email'),
      "rules": _vm.emailRules,
      "required": ""
    },
    model: {
      value: (_vm.edit.email),
      callback: function($$v) {
        _vm.$set(_vm.edit, "email", $$v)
      },
      expression: "edit.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-3",
    attrs: {
      "xs12": "",
      "sm5": "",
      "lg3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('account.label-role'),
      "items": _vm.roles,
      "item-text": "name",
      "item-value": "id",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-role'); }],
      "required": "",
      "disabled": _vm.userRole == _vm.rootRoleName,
      "hint": _vm.userRole == _vm.rootRoleName ? 'root account can only make admin role' : '',
      "persistent-hint": ""
    },
    model: {
      value: (_vm.edit.roleId),
      callback: function($$v) {
        _vm.$set(_vm.edit, "roleId", $$v)
      },
      expression: "edit.roleId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-3",
    attrs: {
      "xs12": "",
      "sm5": "",
      "lg3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('account.label-belongto'),
      "items": _vm.organizations,
      "item-text": "name",
      "item-value": "organizationId",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-org-select'); }],
      "required": "",
      "auto": "",
      "hint": _vm.userRole == _vm.rootRoleName ? 'root account can make accounts under the child organization only.' : '',
      "persistent-hint": ""
    },
    model: {
      value: (_vm.edit.organizationId),
      callback: function($$v) {
        _vm.$set(_vm.edit, "organizationId", $$v)
      },
      expression: "edit.organizationId"
    }
  }), _vm._v(" "), (_vm.edit.roleId === 8 && _vm.edit.organizationId) ? _c('visible-locations-set', {
    attrs: {
      "editProp": _vm.edit
    },
    on: {
      "child-action": _vm.setViewerPermission
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "red--text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 5000,
      "absolute": "",
      "top": "",
      "right": "",
      "color": "teal lighten-2",
      "multi-line": ""
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.$t('account.success-dialog')) + " "), _c('br'), _vm._v("\n  " + _vm._s(_vm.successMessage) + "\n  ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-3f8081b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountUserInvite.vue
// module id = 1920
// module chunks = 0